import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type CircleIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const CircleIcon = ({ strokeWidth, ...props }: CircleIconProps) => {
  return (
    <BaseIcon
      strokeWidth={strokeWidth}
      title="Circle Icon"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      {...props}
    >
      <circle cx="6" cy="6" r="6" />
    </BaseIcon>
  );
};

CircleIcon.displayName = 'CircleIcon';
